(() => {
  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

  const supertabsContainerList = document.getElementsByClassName('super-tabs');
  if (!supertabsContainerList.length) return;

  for (let supertabsContainer of supertabsContainerList) {
    const supertabsTabPanels = supertabsContainer.getElementsByClassName('tab-panel');
    if (!supertabsTabPanels.length) continue;

    const supertabsNavLinks = supertabsContainer.getElementsByClassName('nav-link');
    if (!supertabsNavLinks.length) continue;

    if (width > 991) {
      supertabsTabPanels[0].classList.add('active', 'show');
      supertabsNavLinks[0].classList.add('active');
    } 
    else {
      let tabIndex = 0;
      for (let tabPanel of supertabsTabPanels) {
        const idx = tabIndex;
        tabPanel.addEventListener('click', (ev) => {
          ev.preventDefault();
          tabPanel.classList.remove('active', 'show');
          supertabsNavLinks[idx].classList.remove('active');
        });
      }
    }
  }
})();